import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const MCACoursePage: React.FC = () => {
  const courseData = {
    title: "MCA (Master of Computer Applications)",
    shortName: "MCA",
    duration: "3 years",
    description: "Advanced computer applications program for software development and IT management",
    overview: "Master of Computer Applications (MCA) is a 3-year postgraduate program that provides advanced knowledge in computer applications, software development, and information technology management. This course covers programming languages, software engineering, database management, networking, and emerging technologies, preparing students for senior technical roles and IT leadership positions.",
    eligibility: [
      "Bachelor's degree (preferably BCA/B.Sc CS/IT)",
      "Mathematics at 10+2 or graduation level",
      "Minimum 50% marks in graduation (45% for SC/ST)",
      "Valid entrance exam scores (NIMCET/State CET)"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Advanced Programming in C++",
          "Data Structures and Algorithms",
          "Database Management Systems",
          "Computer Networks",
          "Operating Systems",
          "Software Engineering"
        ]
      },
      {
        year: 2,
        subjects: [
          "Web Technologies",
          "Mobile Application Development",
          "Artificial Intelligence",
          "Machine Learning",
          "Cloud Computing",
          "Cyber Security"
        ]
      },
      {
        year: 3,
        subjects: [
          "Advanced Software Engineering",
          "Big Data Analytics",
          "Internet of Things (IoT)",
          "Blockchain Technology",
          "Project Management",
          "Major Project & Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Software Architect",
        "IT Project Manager",
        "System Analyst",
        "Database Administrator",
        "Technical Lead",
        "Software Development Manager",
        "Data Scientist",
        "Cybersecurity Specialist",
        "Product Manager",
        "IT Consultant"
      ],
      industries: [
        "Software Development",
        "Information Technology Services",
        "Banking & Financial Services",
        "E-commerce & Digital Platforms",
        "Healthcare IT",
        "Government IT Departments",
        "Telecommunications",
        "Consulting Firms",
        "Research & Development",
        "Startups & Technology Companies"
      ],
      averageSalary: "₹6-12 LPA (Fresher), ₹15-40 LPA (Experienced)",
      topRecruiters: [
        "TCS, Infosys, Wipro",
        "Google, Microsoft, Amazon",
        "IBM, Oracle, SAP",
        "Accenture, Cognizant",
        "HDFC Bank, ICICI Bank",
        "Flipkart, Paytm, Zomato"
      ]
    },

    admissionProcess: [
      "NIMCET (National Level Entrance)",
      "State-level entrance examinations",
      "University-specific entrance tests",
      "Merit-based admission",
      "Counseling and seat allotment",
      "Document verification and admission"
    ],

    topColleges: [
      {
        name: "National Institute of Technology",
        location: "Various Cities",
        fees: "₹2-4 Lakhs",
        ranking: "NIRF Ranking: Top 20"
      },
      {
        name: "Jawaharlal Nehru University",
        location: "New Delhi",
        fees: "₹1.5 Lakhs",
        ranking: "Central University"
      },
      {
        name: "Loyola College",
        location: "Chennai",
        fees: "₹3 Lakhs",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Christ University",
        location: "Bangalore",
        fees: "₹4.5 Lakhs",
        ranking: "Private University"
      }
    ],

    skills: [
      "Advanced Programming",
      "System Design & Architecture",
      "Database Management",
      "Web & Mobile Development",
      "Cloud Technologies",
      "Data Analytics",
      "Project Management",
      "Team Leadership",
      "Problem Solving",
      "Emerging Technologies"
    ],

    futureScope: "Excellent opportunities in artificial intelligence, machine learning, cloud computing, cybersecurity, and emerging technologies with high demand for skilled IT professionals.",

    faqs: [
      {
        question: "What is the difference between MCA and M.Tech CSE?",
        answer: "MCA focuses more on computer applications and software development, while M.Tech CSE emphasizes research and advanced computer science concepts. Both lead to similar career opportunities."
      },
      {
        question: "Can I pursue MCA without BCA background?",
        answer: "Yes, graduates from B.Sc (CS/IT/Math), BE/B.Tech can pursue MCA. However, having mathematics background is usually mandatory."
      },
      {
        question: "Is MCA equivalent to engineering degree?",
        answer: "MCA is recognized as equivalent to engineering degree by most companies and government organizations for recruitment purposes, especially in IT sector."
      },
      {
        question: "What are the research opportunities after MCA?",
        answer: "MCA graduates can pursue Ph.D. in Computer Science/IT, work in R&D departments, or join research institutions focusing on emerging technologies."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0a183d] via-black to-[#1a2746] flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow animate-glow mb-8 text-center">
        {courseData.title}
      </h1>
      <div className="w-full max-w-5xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default MCACoursePage;
